import {NavItem} from '@interfaces/nav-item';


export const navItemsSuperadmin: NavItem[] = [
  {
    navCap: 'MENU',
  },
  {
    displayName: 'Dashboard',
    iconName: 'solar:widget-add-line-duotone',
    route: '/dashboard',
  },
  {
    displayName: 'Support',
    iconName: 'material-symbols:support-agent',
    route: '/support/room/list',
  },
  {
    displayName: 'Filemanager',
    iconName: 'solar:inbox-archive-broken',
    route: '/filemanager',
  },
  {
    displayName: 'Field Technicians',
    iconName: 'mdi:account-hard-hat-outline',
    route: '/users/technicians',
  }
];
